import { type MaybeRef } from 'vue';
import {
  type ValidationError,
  type ForbiddenError,
  type NotFoundError,
  type Conflict,
  type TimeoutError,
  type BaseError,
} from './sbError';

export type OnError<T extends BaseError> = MaybeRef<string> | ((error: T) => void);

export type ErrorHandlerOptions = {
  defaultMessage?: string;
  defaultSolution?: string;
  onValidationError?: OnError<ValidationError>;
  onForbiddenError?: OnError<ForbiddenError>;
  onNotFoundError?: OnError<NotFoundError>;
  onConflictError?: OnError<Conflict>;
  onTimeoutError?: OnError<TimeoutError>;
  onError?: OnError<BaseError>;
  severity?: ErrorSeverity;
};

export enum ErrorSeverity {
  Warning = 'warn',
  Error = 'error',
}
